// Display formatters — AUD currency, grams, mm, percentages, null-safe.

export const aud = (n: number | null | undefined, opts: { round?: boolean } = {}): string =>
  n == null
    ? '—'
    : new Intl.NumberFormat('en-AU', {
        style: 'currency', currency: 'AUD',
        maximumFractionDigits: opts.round ? 0 : 2,
      }).format(n)

export const num = (n: number | null | undefined, dp = 1): string =>
  n == null ? '—' : n.toFixed(dp)

export const mm = (n: number | null | undefined): string => (n == null ? '—' : `${num(n, 1)}mm`)

export const grams = (n: number | null | undefined): string => (n == null ? '—' : `${num(n, 1)}g`)

export const pct = (n: number | null | undefined): string => (n == null ? '—' : `${Math.round(n)}%`)

export const METAL_LABELS: Record<string, string> = {
  '18ct yellow gold': '18ct Yellow', '18ct white gold': '18ct White', '18ct rose gold': '18ct Rose',
  '9ct yellow gold': '9ct Yellow', '9ct white gold': '9ct White', '9ct rose gold': '9ct Rose',
  '14ct': '14ct', 'platinum 950': 'Platinum', 'palladium': 'Palladium',
  'titanium': 'Titanium', 'tungsten': 'Tungsten', 'zirconium': 'Zirconium',
  'sterling silver': 'Sterling', 'two-tone': 'Two-tone', 'other': 'Other',
}
export const metalLabel = (m: string | null): string => (m ? METAL_LABELS[m] ?? m : '—')
